export enum StaffAction {
  SELF_EDIT = 'self_edit',
  EDIT = 'edit',
  VIEW = 'view',
  CREATE = 'create',
}

export interface IStaff {
  id: string
  firstName: string
  lastName: string
  title: string
  email: string
  phoneNumber: string
  photo?: any
  roles: StaffRole[]
  states?: string[]
  emailInvitationSent: boolean
}

export class Staff implements IStaff {
  id: string
  firstName: string
  lastName: string
  title: string
  email: string
  phoneNumber: string
  uploadedDocument?: any
  roles: StaffRole[]
  emailInvitationSent: boolean
  constructor() {
    this.id = ''
    this.firstName = ''
    this.lastName = ''
    this.title = ''
    this.email = ''
    this.phoneNumber = ''
    this.uploadedDocument = undefined
    this.roles = []
    this.emailInvitationSent = false
  }
  photo?: any
}

export enum StaffRole {
  BusinessManager = 'businessmanager',
  AdminManager = 'adminmanager',
  MarketingExpert = 'marketingexpert',
  SuperAdmin = 'superadmin',
  Executive = 'executive',
  AdminListings = 'adminlistings',
  AdminLaunch = 'adminlaunch',
  AdminContract = 'admincontract',
  AdminTransactions = 'admintransactions',
  AdminFinance = 'adminfinance',
}

export interface IAgencyUrbanXTeam {
  businessManager?: Staff
  adminManager?: Staff
  marketingExpert?: Staff
}

export class AgencyUrbanXTeam implements IAgencyUrbanXTeam {
  businessManager?: Staff
  marketingExpert?: Staff
  adminManager?: Staff
  adminListings?: Staff
  adminLaunch?: Staff
  adminContract?: Staff
  adminTransactions?: Staff
  adminFinance?: Staff
  constructor() {
    this.businessManager = new Staff()
    this.adminManager = new Staff()
    this.marketingExpert = new Staff()
    this.adminListings = new Staff()
    this.adminLaunch = new Staff()
    this.adminContract = new Staff()
    this.adminTransactions = new Staff()
    this.adminFinance = new Staff()
  }
}

export class AgencyUrbanXTeamRequest {
  readonly BusinessManagerId?: string | null
  readonly AdminManagerId?: string | null
  readonly MarketingExpertId?: string | null

  constructor(
    businessManagerId?: string | null,
    adminManagerId?: string | null,
    marketingExpertId?: string | null
  ) {
    this.BusinessManagerId = businessManagerId
    this.AdminManagerId = adminManagerId
    this.MarketingExpertId = marketingExpertId
  }
}
